<template>
  <v-container class="fill-height w-100 pa-0" style="margin-top: 1.6rem">
    <v-row class="no-gutters elevation-0">
      <v-col cols="auto" class="flex-grow-1 flex-shrink-0">
        <v-responsive
          class="overflow-y-hidden fill-height"
          style="padding-bottom: 120px"
          height="405"
        >
          <v-card flat class="d-flex flex-column px-8 fill-height">
            <v-card-text
              @scroll="scrollHeight"
              ref="body"
              class="flex-grow-1 overflow-y-auto"
            >
              <template v-for="(msg, i) in value?.data">
                <div :key="i">
                  <v-hover v-slot="{ hover }" open-delay="100">
                    <v-chip
                      :color="msg?.me ? 'primary' : 'white'"
                      dark
                      :style="{ color: !msg?.me ? 'black' : '' }"
                      style="
                        height: auto;
                        white-space: normal;
                        align-items: start;
                      "
                      class="pa-4 mb-2 text-break"
                    >
                      <v-icon
                        @click="copyTcClipBoard(msg?.content)"
                        size="22"
                        style="cursor: pointer; opacity: 0.7"
                        class="mr-2"
                        v-if="hover || !mobile"
                        >mdi-content-copy</v-icon
                      >
                      <span
                        style="width: 100; padding: 0"
                        v-html="sortText(msg?.content)"
                      />
                    </v-chip>
                  </v-hover>
                </div>
              </template>
              <template v-if="value?.me?.length > 0">
                <div>
                  <v-hover v-slot="{ hover }" open-delay="100">
                    <v-chip
                      color="primary"
                      dark
                      style="
                        height: auto;
                        white-space: normal;
                        align-items: start !important;
                      "
                      class="pa-4 mb-2 text-break"
                    >
                      <v-icon
                        @click="copyTcClipBoard(value?.me)"
                        size="22"
                        style="cursor: pointer; opacity: 0.7"
                        class="mr-2"
                        v-if="hover || !mobile"
                        >mdi-content-copy</v-icon
                      >
                      <span
                        style="width: 100; padding: 0"
                        v-html="sortText(value?.me)"
                      />
                    </v-chip>
                  </v-hover>
                </div>
              </template>
              <template v-if="!endMessage">
                <!-- class="d-flex flex-row-reverse" -->
                <div v-if="value?.ai?.length > 0">
                  <v-hover v-slot="{ hover }" open-delay="100">
                    <v-chip
                      color="white"
                      dark
                      style="
                        height: auto;
                        white-space: normal;
                        color: black;
                        align-items: start !important;
                      "
                      class="pa-4 mb-2 text-break"
                    >
                      <v-icon
                        @click="copyTcClipBoard(value?.ai)"
                        size="22"
                        style="cursor: pointer; opacity: 0.7"
                        class="mr-2"
                        v-if="(hover || !mobile) && !endMessage"
                        >mdi-content-copy</v-icon
                      >
                      <span class="pa-0 w-100" v-html="sortText(value?.ai)" />
                    </v-chip>
                  </v-hover>
                </div>
              </template>
            </v-card-text>
          </v-card>

          <!-- up and down -->
          <v-card
            width="15"
            flat
            color="transparent"
            style="bottom: 3rem"
            class="w-100 possition-absolute d-flex align-items-center justify-content-center"
          >
            <v-icon
              large
              style="cursor: pointer"
              v-for="(item, i) in scroll"
              :key="i"
              @click="scrollToHeight(item?.name)"
              v-show="item.show"
              >{{ item.icon }}</v-icon
            >
          </v-card>

          <!-- loading -->
          <div
            v-if="!endMessage && value?.ai?.length <= 0"
            style="position: absolute; bottom: 10rem; left: 3rem"
          >
            <loading-bot />
          </div>
        </v-responsive>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { throttle } from "lodash-es"; // اگر lodash نداری می‌تونم throttle دستی بدم
import markdownIt from "markdown-it";
import hljs from "highlight.js";
import "highlight.js/styles/github.css";
import loadingBot from "./loadingBot.vue";
export default {
  components: { loadingBot },
  name: "chatBotMessage",
  props: {
    value: [Object],
    endMessage: Boolean,
  },
  data() {
    return {
      scroll: [
        { name: "up", icon: "mdi-arrow-up-bold-circle-outline", show: true },
        {
          name: "down",
          icon: "mdi-arrow-down-bold-circle-outline",
          show: false,
        },
      ],
    };
  },

  mounted() {
    this.scrollHeight();
    this.scrollToHeight();
  },

  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },

  methods: {
    scrollHeight() {
      let minHeight = 285;
      let heigth = this.$refs.body.scrollHeight;
      let location = this.$refs.body.scrollTop;
      let scrollToTop = heigth - location;
      let up = this.$refs.body.clientHeight - scrollToTop;
      if (heigth == minHeight) {
        this.scroll[0].show = false;
        this.scroll[1].show = false;
      } else if (up == 0) {
        this.scroll[0].show = true;
        this.scroll[1].show = false;
      } else if (up < 0) {
        this.scroll[0].show = false;
        this.scroll[1].show = true;
      }
    },
    scrollToHeight(type) {
      console.log("ok");

      const chatBox = this.$refs.body;
      if (type == "up") {
        if (chatBox) {
          chatBox.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      } else {
        const chatBox = this.$refs.body;
        if (chatBox) {
          chatBox.scrollTo({
            top: chatBox.scrollHeight,
            behavior: "smooth",
          });
        }
      }
    },

    // sort text
    sortText(text) {
      const md = markdownIt({
        html: true,
        linkify: true,
        typographer: true,
        highlight: function (str, lang) {
          if (lang && hljs.getLanguage(lang)) {
            try {
              return (
                '<pre  class="hljs"><code>' +
                hljs.highlight(str, { language: lang, ignoreIllegals: true })
                  .value +
                "</code></pre>"
              );
            } catch (__) {}
          }
          return (
            '<pre  class="hljs"><code>' +
            md.utils.escapeHtml(str) +
            "</code></pre>"
          );
        },
      });

      if (!text) return "";
      return md.render(text);
    },

    // copy
    async copyTcClipBoard(value) {
      try {
        await navigator.clipboard.writeText(value);
        this.$toast.success("با موفقیت کپی شد");
      } catch (err) {
        this.$toast.error("در کپی کردن مشکلی پیش آمده");
        console.error("خطا در کپی کردن متن:", err);
      }
    },
  },

  watch: {
    endMessage(val) {
      this.scrollHeight();
      this.scrollToHeight();
    },
    "value.me"(val) {
      this.scrollHeight();
      this.scrollToHeight();
    },
  },
};
</script>

<style>
p {
  margin: 0 !important;
}

.container_aiChat_loading {
  width: 20px;
  aspect-ratio: 1;
  --c: no-repeat linear-gradient(#8e8a8a 0 0);
  background: var(--c), var(--c), var(--c);
  animation: l15-1 1s infinite, l15-2 1s infinite;
  margin-bottom: 1rem;
}

.v-chip .v-chip__content {
  align-items: start !important;
}
@keyframes l15-1 {
  0%,
  100% {
    background-size: 20% 100%;
  }
  33%,
  66% {
    background-size: 20% 40%;
  }
}
</style>
